import Button from '@components/Button';
import { Col, ConfigProvider, Drawer, Row } from 'antd';
import React, { Component } from 'react';
import styles from './ContainerWithAside.module.scss';
import { ContainerWithAsideProps, ContainerWithAsideState } from './ContainerWithAsideModel';

class ContainerWithAside extends Component<ContainerWithAsideProps, ContainerWithAsideState> {
    state = {
        openAside: false
    };

    showAside = () => {
        this.setState({ openAside: true });
    }

    hideAside = () => {
        this.setState({ openAside: false });
    }
    render() {
        const {
            children,
            drawerIcon = 'menu-fold',
            footer,
            renderAside,
            dataAttributes,
            disableContent
        } = this.props;
        return (
            <Row
                {...dataAttributes}
                type="flex"
                justify="center"
                className={
                    `${styles.ContainerWithAsideContainer} 
                    ${disableContent
                        ? styles.ContainerWithAsideContentDisabled
                        : ''
                    }`}
            >
                <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={15}
                    xl={18}
                    className={styles.ContainerWithAsideScrollableContent}
                    id="scrollable-content"
                >
                    <ConfigProvider
                        getPopupContainer={() => document.getElementById('scrollable-content') as HTMLDivElement}
                    >
                        <Row className={styles.ContainerWithAsideContentRowWrapper}>
                            <Col xs={24} style={{ height: footer ? '90%' : '100%' }}>
                                {children}
                            </Col>
                            {footer && <Col xs={24} style={{ height: '10%', display: 'flex', alignItems: 'center' }}>
                                {footer}
                            </Col>}
                        </Row>
                    </ConfigProvider>
                </Col>
                <Col id="scrollable-aside" xs={0} sm={0} md={0} lg={9} xl={6} className={styles.AsideContainer}>
                    <ConfigProvider
                        getPopupContainer={() => document.getElementById('scrollable-aside') as HTMLDivElement}
                    >
                        {renderAside()}
                    </ConfigProvider>
                </Col>
                {!this.state.openAside &&
                    <Button
                        className={styles.ContainerWithAsideDrawerButton}
                        type="primary"
                        icon={drawerIcon}
                        onClick={this.showAside}
                    />
                }
                <Drawer
                    className={styles.ContainerWithAsideDrawer}
                    closable={false}
                    visible={this.state.openAside}
                    onClose={this.hideAside}
                >
                    {renderAside()}
                </Drawer>
            </Row>
        );
    }
}

export default ContainerWithAside;
